import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import { defaultTenant } from "../../../services/academicService";
import { toPng } from "html-to-image";
import { toast } from "react-toastify";

const CoachAttendenceQrModal = ({ show, onClose, url }) => {
  const qrRef = useRef(null);
  const [userDetails, setUserDetails] = useState(null);

  // SIMPLE DOWNLOAD FUNCTION
  const downloadQRCode = async () => {
    if (!qrRef.current) return;

    try {
      const dataUrl = await toPng(qrRef.current);

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "player-qr.png";
      link.click();
      toast.success("QR Code downloaded successfully!", {
        position: "top-right",
        autoClose: 1000,
      });
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  async function fetchUserDetails() {
    try {
      const res = await defaultTenant();
      console.log("Fetched user details:", res);
      setUserDetails(res);
    } catch (error) {
      console.error("Error fetching coach skills:", error);
    }
  }

  // const shareQRCode = async () => {
  //   const canvas = qrRef.current.querySelector("canvas");

  //   if (!navigator.share || !canvas) {
  //     alert("Sharing not supported on this device.");
  //     return;
  //   }

  //   canvas.toBlob(async (blob) => {
  //     const file = new File([blob], "player-qr.png", { type: "image/png" });

  //     try {
  //       await navigator.share({
  //         title: "Player Registration QR",
  //         text: "Scan this QR to register",
  //         files: [file],
  //       });
  //     } catch (error) {
  //       console.error("Sharing failed:", error);
  //     }
  //   });
  // };

  const shareQRCode = async () => {
    if (!qrRef.current) return;

    if (!navigator.share) {
      toast.warning("Sharing not supported on this device.", {
        position: "top-right",
        autoClose: 1000,
      });
      return;
    }

    try {
      const dataUrl = await toPng(qrRef.current);
      const blob = await (await fetch(dataUrl)).blob();

      const file = new File([blob], "player-qr.png", {
        type: "image/png",
      });

      await navigator.share({
        title: "Coach Attendence QR",
        text: "Scan this QR to mark your attendence",
        files: [file],
      });
    } catch (error) {
      console.error("Sharing failed:", error);
    }
  };

  const qrUrl = `${url}/${userDetails?.defaultTenant?.tenant?.id}`;

  const copyQrUrl = async () => {
    if (!qrUrl) return;

    try {
      await navigator.clipboard.writeText(qrUrl);
      toast.success("Link copied to clipboard!", {
        position: "top-right",
        autoClose: 1000,
      });
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title className="text-center">Coach Attendence</Modal.Title>
        {/* <Button variant="" className="btn-close" onClick={onClose} /> */}
        <div className="d-flex align-items-center gap-2">
          {/* Copy Link Button */}
          <Button
            variant="link"
            className="text-decoration-none d-flex align-items-center gap-1 p-0"
            onClick={copyQrUrl}
          >
            <i className="fa fa-link" />
            <span style={{ fontSize: "14px" }}>Copy Link</span>
          </Button>

          {/* Close Button */}
          <Button
            variant=""
            className="btn-close"
            onClick={onClose}
            style={{ transform: "scale(1.4)" }}
          />
        </div>
      </Modal.Header>

      <Modal.Body className="text-center px-4 py-4">
        <div ref={qrRef}>
          <h5 className="card-title">Attendence QR</h5>

          {/* Subtitle */}
          <p className="text-muted small mb-4">
            Scan this QR and mark your attendence
          </p>

          {/* QR Code */}
          <div
            className="d-flex justify-content-center align-items-center mb-4 bg-white border rounded-3"
            style={{
              padding: "14px",
              width: "fit-content",
              margin: "0 auto",
            }}
          >
            <QRCodeCanvas
              value={qrUrl}
              size={200}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
            />
          </div>
        </div>
        {/* Action Buttons */}
        <div className="d-flex justify-content-center gap-3">
          <Button
            variant="outline-primary"
            className="px-4 rounded-pill"
            onClick={downloadQRCode}
          >
            <i className="fa fa-download me-2" />
            Download
          </Button>

          <Button
            variant="primary"
            className="px-4 rounded-pill"
            onClick={shareQRCode}
          >
            <i className="fa fa-share-alt me-2" />
            Share
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CoachAttendenceQrModal;
